<template>
  <div class="fudongBut">
      <button 
        class="back-to-top"
        :class="{ 'visible': isVisible }"
        @click="scrollToTop"
      >
        <i class="iconfont icon-gotop1"></i>
      </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false // 控制按钮显示/隐藏
    };
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    // 处理滚动逻辑
    handleScroll() {
      // 滚动超过200px时显示按钮，否则隐藏
      this.isVisible = window.scrollY > 200;
    },
    // 滚动到顶部
    scrollToTop() {
      // 平滑滚动到顶部
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  },
  beforeDestroy() {
    // 移除滚动监听，避免内存泄漏
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style scoped>
.back-to-top {
  /* 固定在右下角 */
  position: fixed;
  right: 20px;
  bottom: 40px;
  cursor: pointer;
  
  /* 圆形按钮 */
  width: 50px;
  height: 50px;
  border-radius: 50%;
  
  /* 半透明白色背景 + 高斯模糊 */
  background-color: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  
  /* 去除默认边框和样式 */
  border: none;
  padding: 0;
  margin: 0;
  
  /* 箭头样式 */
  color: #333; /* 箭头颜色 */
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  /* 阴影增强立体感 */
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.15);
  
  /* 初始隐藏 */
  opacity: 0;
  visibility: hidden;
  pointer-events: none; /* 隐藏时不响应点击 */
  
  /* 过渡动画（渐显渐隐 + 轻微缩放） */
  transition: all 0.3s ease;
  /* transform: scale(0.9); */
  transform: rotateX(180deg);
  -webkit-transform: rotateX(180deg); /* Safari 与 Chrome */
}

/* 显示状态 */
.back-to-top.visible {
  cursor: pointer;
  opacity: 1;
  visibility: visible;
  pointer-events: auto; /* 显示时响应点击 */
  /* transform: scale(1);  */
  transform: rotateX(0deg);
  -webkit-transform: rotateX(0deg); /* Safari 与 Chrome */
}
.icon-gotop1 {
	font-size: 26px;
}
/* 点击反馈 */
.back-to-top:active {
  transform: scale(0.95);
  background-color: rgba(255, 255, 255, 0.8);
}

/* 箭头微调 */
.arrow-up {
  transform: translateY(-1px); /* 视觉居中 */
}
</style>
